declare let Tiff;
export const convertTiff = file => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (function (file) {
            return function (event) {
                const tiff = new Tiff({ buffer: event.target.result });
                const canvas = tiff.toCanvas();
                //const div = $('div');
                //div.append(canvas);
                resolve(canvas.toDataURL());
            }
        })(file)
        reader.readAsArrayBuffer(file);
    });
}

export const convert = file => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            file.base64Image = reader.result;
            resolve(file.base64Image);
        }
        reader.readAsDataURL(file);
        reader.onerror = error => {
            console.warn('Error reading file', error);
            reject(error);
        }
    });
}
